import {Record} from 'immutable';

export default class TrendMatchedItems extends Record({
  ruleItems: undefined,
  antiRuleItems: undefined,
  moreItems: false,
}) {}
